import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { AuthToken } from "./auth/auth-store";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL

const token = AuthToken();

type RequestType = {
  endpoint: string;
  method: "GET" | "POST";
  payload?: any;
  responseType?: any
};

type ResponseType = {
  data?: any;
  status: string;
  message: string;
};


const ApiRequest = async ({
  endpoint,
  method,
  payload = [],
  responseType = 'json', // default
}: RequestType & { responseType?: 'json' | 'blob' | 'arraybuffer' }) => {
  let headers: any = {
    'Content-Type': 'application/json',
    accept: "*/*",
  };

  token && (headers['Authorization'] = `Bearer ${token}`);

  try {
    axiosRetry(axios, { retries: 1 });
    const response = await axios.request({
      method,
      url: endpoint,
      data: payload,
      headers,
      responseType, // important!
    });
    return responseType === 'json' ? response.data : response; // return raw response for blob
  } catch (e) {
    return {
      status: "error",
      message: "Error processing request, try again.",
      data: e,
    };
  }
};

export default ApiRequest;